<template>
  <b-card>
    <b-row>
      <b-col>
        <h3 tabindex="0">{{conferencia.id > 0 ? 'Editar' : 'Cadastrar'}} Conferência</h3>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="salvar">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Nome da Conferência: *">
            <b-form-input id="nome" v-model.trim="conferencia.nome" required/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Sigla:">
            <b-form-input id="sigla" v-model.trim="conferencia.sigla"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
        <b-form-group label="Área:">
          <b-form-select v-model="conferencia.area_id" required>
             <option :value="null" selected> Selecione </option>
             <option v-for="item in areas" :key="item.id" :value="item.id"> {{item.titulo}}</option>
          </b-form-select>
        </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Status: *">
            <b-form-radio-group id="status" v-model="conferencia.status" :options="status" required/>
          </b-form-group>
        </b-col>

      </b-row>
      <b-row>
        <b-col sm="2">
          <b-button block @click="voltar()">
            <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
          </b-button>
        </b-col>
        <b-col sm="8"/>
        <b-col sm="2">
          <b-row no-gutters align-h="end">
            <b-col v-if="!loading">
            <b-button block type="submit" variant="primary">
              <i class="fa fa-floppy-o"/>&nbsp;&nbsp;Salvar
            </b-button>
            </b-col>
            <b-col v-else>
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import Vue from 'vue'
import { VueEditor } from "vue2-editor";
import { mapState } from 'vuex'

export default {
  components: {
    VueEditor
  },
  created () {
    this.$store.dispatch('getAreasAtivas')
  },
  data () {
    return {
      conferencia: {
        id: parseInt(this.$route.params.idConferencia),
        nome: null,
        sigla: null,
        status: null,
        area_id: null
      },
      original: null,
      loading: false,
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ]
    }
  },
    computed: {
    ...mapState({
      areas: state => state.area.lista
    })
  },
  mounted () {
    this.carregar()
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    carregar () {
      if (this.conferencia.id > 0) {
        Vue.http.get('api/conferencia/index/' + this.conferencia.id).then(response => {
          if (response.body.success) {
            this.conferencia = response.body.data
            this.original = {
              id: this.conferencia.id,
              nome: this.conferencia.nome,
              sigla: this.conferencia.sigla,
              status: this.conferencia.status,
              area_id: this.conferencia.area_id
            }
          }
        })
      }
    },
    salvar () {
      if (this.conferencia.nome.trim().length === 0) {
        this.erro('Valor do campo "Nome da Conferência" é inválido!')
      }
      this.loading = true
      Vue.http.post('api/conferencia/duplicado', {id: this.conferencia.id, nome: this.conferencia.nome}).then(response => {
        if (response.body.success) {
          let contagem = response.body.data

          if (contagem > 0) {
            this.erro('Já existe conferência salva com este nome.')
            this.loading = false
          } else {  
            
            this.$bvModal.msgBoxConfirm(this.conferencia.id > 0 ? 'Deseja editar a conferência?' : 'Deseja salvar a conferência?', {
              noCloseOnBackdrop: true,
              centered: true,
              okTitle: 'Confirmar',
              cancelTitle: 'Cancelar'
            }).then(valor => {
              if (valor) {
                this.loading = true
                Vue.http.post('api/conferencia/salvar', this.conferencia).then(response => {
                  if (response.body.success) {
                    this.$store.commit('setMensagemConferencia', 'Conferência salva com sucesso!')
                    this.navigate('/conferencias')
                  }
                })
              }
            })
             this.loading = false
          }
        }
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    voltar () {
      if ((this.conferencia.id <= 0 && (this.conferencia.nome || this.conferencia.sigla || this.conferencia.status !== null)) ||
          (this.conferencia.id > 0 && (this.conferencia.nome !== this.original.nome ||
            (!this.conferencia.sigla && this.original.sigla) ||
            (this.conferencia.sigla && !this.original.sigla) ||
            (this.conferencia.sigla && this.original.sigla && this.conferencia.sigla !== this.original.sigla) ||
            this.conferencia.status !== this.original.status))) {
        this.$bvModal.msgBoxConfirm(this.conferencia.id <= 0 ? 'Tem certeza que deseja voltar? As informações inseridas serão perdidas.' : 'Tem certeza que deseja voltar? As informações alteradas serão perdidas.', {
          noCloseOnBackdrop: true,
          centered: true,
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        }).then(valor => {
          if (valor) {
            this.navigate('/conferencias')
          }
        })
      } else {
        this.navigate('/conferencias')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Cadastrar.vue